import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { baseApi } from './api/baseApi';
import appSlice from './slices/appSlice';
import userSlice from './slices/userSlice';
import uiSlice from './slices/uiSlice';
import contentSlice from './slices/contentSlice';

export const store = configureStore({
  reducer: {
    app: appSlice,
    user: userSlice,
    ui: uiSlice,
    content: contentSlice,
    // 添加RTK Query API reducer
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    })
    // 添加RTK Query middleware
    .concat(baseApi.middleware),
  devTools: process.env.NODE_ENV !== 'production',
});

// 启用RTK Query的refetchOnFocus/refetchOnReconnect行为
setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;